import { addOrUpdateDetailInfo, getParentNameList } from '../api'

export default {
  data() {
    const statusList = [
      { id: 1, name: 'AAA' },
      { id: 2, name: 'AA+' },
      { id: 3, name: 'AA' },
      { id: 4, name: 'AA-' },
      { id: 5, name: 'A+' },
      { id: 6, name: 'A' },
      { id: 7, name: 'A-' },
      { id: 8, name: 'BBB+' },
      { id: 9, name: 'BBB' },
      { id: 10, name: 'BBB-' },
      { id: 11, name: 'BB+' },
      { id: 12, name: 'BB' },
      { id: 13, name: 'BB-' },
      { id: 14, name: 'B+' },
      { id: 15, name: 'B' },
      { id: 16, name: 'B-' },
      { id: 17, name: 'CCC+' },
      { id: 18, name: 'CCC' },
      { id: 19, name: 'CCC-' },
      { id: 20, name: 'CC' },
      { id: 21, name: 'C' },
      { id: 22, name: 'D' },
    ]
    return {
      addInfoSchema: [
        {
          label: 'Global Customer Rating',
          type: 'select',
          placeholder: 'All',
          key: 'globalCustomerRating',
          selectList: [
            { id: 1, name: '1' },
            { id: 2, name: '2' },
            { id: 3, name: '3' },
            { id: 4, name: '4' },
            { id: 5, name: '5' },
            { id: 6, name: '6' },
            { id: 7, name: '7' },
            { id: 'NR', name: 'NR' },
          ],
        },
        {
          label: 'Country Risk Rating',
          type: 'select',
          placeholder: 'All',
          key: 'countryRiskRating',
          selectList: [
            { id: 1, name: '1' },
            { id: 2, name: '2' },
            { id: 3, name: '3' },
            { id: 4, name: '4' },
            { id: 5, name: '5' },
            { id: 6, name: '6' },
            { id: 7, name: '7' },
            { id: 'NR', name: 'NR' },
          ],
        },
        // {
        //   label: 'Agency Rating',
        //   type: 'input',
        //   key: 'moodysPoorRating',
        // },
        {
          label: "Moody's Rating",
          type: 'select',
          placeholder: 'All',
          key: 'moodys',
          selectList: [
            { id: 1, name: 'Aaa' },
            { id: 2, name: 'Aa1' },
            { id: 3, name: 'Aa2' },
            { id: 4, name: 'Aa3' },
            { id: 5, name: 'A1' },
            { id: 6, name: 'A2' },
            { id: 7, name: 'A3' },
            { id: 8, name: 'Baa1' },
            { id: 9, name: 'Baa2' },
            { id: 10, name: 'Baa3' },
            { id: 11, name: 'Ba1' },
            { id: 12, name: 'Ba2' },
            { id: 13, name: 'Ba3' },
            { id: 14, name: 'B1' },
            { id: 15, name: 'B2' },
            { id: 16, name: 'B3' },
            { id: 17, name: 'Caa1' },
            { id: 18, name: 'Caa2' },
            { id: 19, name: 'Caa3' },
            { id: 20, name: 'Ca1' },
            { id: 21, name: 'Ca2' },
            { id: 22, name: 'C' },
          ],
          tooltip: 'modifyUpdateTime',
        },
        {
          label: "Standard & Poor's Rating",
          type: 'select',
          placeholder: 'All',
          key: 'sp',
          selectList: statusList,
          tooltip: 'spUpdateTime',
        },
        {
          label: 'Fitch Rating',
          type: 'select',
          placeholder: 'All',
          key: 'fitch',
          selectList: statusList,
          tooltip: 'fitchUpdateTime',
        },
        {
          label: 'Other External Rating',
          type: 'input',
          key: 'otherExternalRating',
        },
        {
          label: 'CRMZ Frisk score',
          type: 'input',
          key: 'crmzFriskScore',
          tooltip: 'cfsUpdateTime',
        },
        {
          label: 'Onshore/Offshore',
          type: 'select',
          placeholder: 'All',
          key: 'onOffshore',
          selectList: [
            { id: 1, name: 'Onshore' },
            { id: 2, name: 'Offshore' },
          ],
        },
        {
          label: 'Adverse Business Status',
          type: 'select',
          placeholder: '',
          key: 'businessStatus',
          selectList: [
            { id: 1, name: 'Bankruptcy' },
            { id: 2, name: 'Black List' },
            { id: 3, name: 'Fraud Attempt' },
            { id: 4, name: 'Liquidation' },
            { id: 5, name: 'No Trading' },
            { id: 6, name: 'Out of Business' },
            { id: 7, name: 'Outside Collection Agency' },
          ],
        },
        // {
        //   label: 'Parent Name',
        //   type: 'select',
        //   placeholder: 'All',
        //   key: 'parentName',
        //   selectList: [],
        // },
        // {
        //   label: 'DBA',
        //   type: 'input',
        //   key: 'oldCustomerNumber',
        // },
        {
          label: 'Working Capital',
          type: 'input',
          key: 'workingCapital',
        },
        {
          label: 'Net Worth',
          type: 'input',
          key: 'netWorth',
        },
        {
          label: 'Current Ratio',
          type: 'input',
          key: 'currentRatio',
        },
        {
          label: 'Total Employees',
          type: 'input',
          key: 'totalEmployees',
        },
        {
          label: 'Total Exposure (AR + Backlog)',
          type: 'input',
          key: 'sumArBacklogAmount',
        },
        {
          label: 'Latest AR Past Due Percent',
          type: 'input',
          key: 'latestArPastDuePercent',
        },
        {
          label: 'Revenue to Lenovo in last 12 mths',
          type: 'input',
          key: 'revenueLenovoLast12',
        },
        {
          label: 'Average Overdue Ratio in last 12 mths',
          type: 'input',
          key: 'averageOverdueRatioLast12',
        },
        {
          label: 'Overdue Amount >= 60 Days',
          type: 'input',
          key: 'overdueAmount60',
        },
        {
          label: '30+ Overdue Ratio',
          type: 'input',
          key: 'overdueRatio30',
        },
        {
          label: 'Paytrend or Average Aging',
          type: 'input',
          key: 'paytrendOrAverageAging',
        },
        {
          label: 'Industry Rank',
          type: 'select',
          placeholder: 'All',
          key: 'industryRank',
          selectList: [
            { id: 1, name: 'Challenger' },
            { id: 2, name: 'Follower' },
            { id: 3, name: 'Gov(Above AA)' },
            { id: 4, name: 'Gov(Below AA)' },
            { id: 5, name: 'Leader' },
            { id: 6, name: 'New Comer' },
          ],
        },
        {
          label: 'Government Budget',
          type: 'select',
          placeholder: '',
          key: 'governmentBudget',
          selectList: [
            { id: 1, name: 'Adequate' },
            { id: 2, name: 'Inadequate' },
            { id: 3, name: 'No Information' },
          ],
        },
        {
          label: 'Government Level',
          type: 'select',
          placeholder: '',
          key: 'governmentLevel',
          selectList: [
            { id: 1, name: 'City' },
            { id: 2, name: 'County' },
            { id: 3, name: 'Federal/Country' },
            { id: 4, name: 'State/Province' },
          ],
        },
        {
          label: 'Concentration Risk',
          type: 'select',
          placeholder: 'All',
          key: 'concentrationRisk',
          selectList: [
            { id: 1, name: 'High' },
            { id: 2, name: 'Medium High' },
            { id: 3, name: 'Medium' },
            { id: 4, name: 'Medium Low' },
            { id: 5, name: 'Low' },
          ],
        },
        {
          label: 'Industry Risk',
          type: 'select',
          placeholder: 'All',
          key: 'industryRisk',
          selectList: [
            { id: 1, name: 'High' },
            { id: 2, name: 'Medium High' },
            { id: 3, name: 'Medium' },
            { id: 4, name: 'Medium Low' },
            { id: 5, name: 'Low' },
          ],
        },
        {
          label: 'Financial Report Quality',
          type: 'select',
          placeholder: 'All',
          key: 'financialReportQuality',
          selectList: [
            { id: 1, name: 'Agency Report' },
            { id: 2, name: 'Audited by Int I Firm' },
            { id: 3, name: 'Audited by Local Accounting Fm' },
            { id: 4, name: 'Audited by Top 4' },
            { id: 5, name: 'Qualified Audit Report' },
            { id: 6, name: 'Unaudited/Accting Software' },
          ],
        },

        {
          label: 'Financial Performance Trend',
          type: 'select',
          placeholder: 'All',
          key: 'financialPerformanceTrend',
          selectList: [
            { id: 1, name: 'Decreasing' },
            { id: 2, name: 'Increasing' },
            { id: 3, name: 'No Report' },
            { id: 4, name: 'Stable' },
            { id: 5, name: 'Unstable' },
          ],
        },
        // {
        //   label: 'Group Customer',
        //   type: 'select',
        //   placeholder: 'All',
        //   key: 'groupCustomer',
        //   selectList: [
        //     { id: 1, name: 'Yes' },
        //     { id: 2, name: 'No' },
        //   ],
        // },
        // {
        //   label: 'Group Total Approved Limit',
        //   type: 'input',
        //   key: 'groupTotalApprovedLimit',
        // },

        // {
        //   label: 'Total Net Worth/Capital',
        //   type: 'input',
        //   key: 'totalNetWorthCapital',
        // },

        // {
        //   label: 'Expiry Date of Parent Acct',
        //   type: 'date',
        //   key: 'groupAccLimitExpiredDate',
        // },
        {
          label: 'Expiry Date of Latest Credit Limit',
          type: 'date',
          key: 'latestCreditLimitExpiryDate',
        },

        {
          label: 'Temp Uplift Limit Expire Date',
          type: 'date',
          key: 'tempUpliftLimitExpiryDate',
        },
        {
          label: 'Approval w Condition',
          type: 'select',
          placeholder: 'All',
          key: 'approvalWCondition',
          selectList: [
            { id: 1, name: 'AR Payment' },
            { id: 2, name: 'Collateral' },
            { id: 3, name: 'Insurance' },
            { id: 4, name: 'Local support' },
            { id: 5, name: 'PDC' },
            { id: 6, name: 'Recent financial' },
            { id: 7, name: 'Watch list' },
          ],
        },
        // {
        //   label: 'WW:Consumer BP',
        //   type: 'select',
        //   placeholder: 'All',
        //   key: 'consumerBp',
        //   selectList: [
        //     { id: 1, name: 'YES' },
        //     { id: 2, name: 'NO' },
        //   ],
        // },
        {
          label: 'GLN',
          type: 'input',
          key: 'gln',
        },
        {
          label: 'ILN',
          type: 'input',
          key: 'iln',
        },
      ],
      isShowAddInfoForm: false,
    }
  },
  mounted() {
    this._getParentNameList()
  },
  methods: {
    async _getParentNameList() {
      try {
        const res = await getParentNameList(this.$route.params.customerId)
        if (Array.isArray(res) && res.length) {
          this.addInfoSchema.forEach(item => {
            if (item.key === 'parentName') {
              item.selectList = res
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async handleAddInfoSaveBtn() {
      try {
        const params = this.$refs.addInfo.getFormData()
        const filterList = [
          'netWorth',
          'totalNetWorthCapital',
          'revenueLenovoLast12',
          'workingCapital',
          'overdueAmount60',
          'groupTotalApprovedLimit',
          'sumArBacklogAmount',
          'totalEmployees',
        ]
        filterList.forEach(key => {
          const value = params[key]
          params[key] = this.$utils.resetAmount(value)
        })
        params.moodys === 'NR' ? (params.moodys = 23) : params.moodys,
          params.sp === 'NR' ? (params.sp = 23) : params.sp,
          params.fitch === 'NR' ? (params.fitch = 23) : params.fitch,
          await addOrUpdateDetailInfo({
            ...params,
            companyId: this.customerInfo.base.id,
          })
        this.isShowAddInfoForm = false
        await this._getCustomerInfo()
      } catch (err) {
        console.error(err)
        return Promise.reject(err)
      }
    },
  },
}
